import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import Icon from 'dpl/common/components/Icon';
import NotificationCount from 'dpl/common/components/NotificationCount';
import { FancyDropdownMenuItem } from 'dpl/components/FancyDropdown';
import SmartLink from 'dpl/components/SmartLink';
import { hasPuppyCollegeAccess } from 'dpl/shared/buyer/utils';
import {
  BUYER_APPLICATIONS_PATH,
  BUYER_FAVORITES_PATH,
  BUYER_MESSAGES_PATH,
  BUYER_OWNER_HUB_PATH,
  BUYER_PAYMENTS_PATH,
  BUYER_SETTINGS_PATH,
  HELP_BUYERS_PATH,
  PUPPY_TRAINING_PROGRAM,
  PUPPY_TRAINING_PROGRAM_LANDING,
  ROOT_HOST
} from 'dpl/shared/constants/urls';

export default function UserHeaderLoggedInBuyerMenu({
  user,
  totalNotificationsCount
}) {
  const { pathname } = window.location;

  const puppyTrainingLink = hasPuppyCollegeAccess(user?.entitlements)
    ? PUPPY_TRAINING_PROGRAM
    : PUPPY_TRAINING_PROGRAM_LANDING;

  const menuLinks = useMemo(
    () => [
      {
        id: 'messages',
        label: 'Messages',
        iconName: 'fetch-message',
        path: BUYER_MESSAGES_PATH,
        notificationCount: totalNotificationsCount
      },
      {
        id: 'applications',
        label: 'Applications',
        iconName: 'fetch-application-alt',
        path: BUYER_APPLICATIONS_PATH
      },
      {
        id: 'your-puppy',
        label: 'Your puppy',
        iconName: 'fetch-dog',
        path: BUYER_OWNER_HUB_PATH
      },
      {
        id: 'favorites',
        label: 'Favorites',
        iconName: 'fetch-heart',
        path: BUYER_FAVORITES_PATH
      },
      {
        id: 'payments',
        label: 'Payments',
        iconName: 'fetch-payment',
        path: BUYER_PAYMENTS_PATH
      },
      {
        id: 'puppy-training',
        label: 'Puppy Training',
        iconName: 'fetch-dog-square',
        path: puppyTrainingLink
      },
      {
        id: 'help',
        label: 'Help',
        iconName: 'fetch-help',
        path: HELP_BUYERS_PATH
      },
      {
        id: 'settings',
        label: 'Account Settings',
        iconName: 'fetch-settings',
        path: BUYER_SETTINGS_PATH
      }
    ],
    [totalNotificationsCount, puppyTrainingLink]
  );

  return (
    <>
      {menuLinks.map(({ id, label, iconName, path, notificationCount }) => (
        <FancyDropdownMenuItem key={id} itemKey={id}>
          <SmartLink
            to={`${ROOT_HOST}${path}`}
            className={classnames(
              'flex items-center gap-12 w-100 pv2 ph3 nowrap font-16 fw-medium transition',
              pathname.startsWith(path) ? 'stone-700' : 'secondary'
            )}
          >
            <Icon
              className="tertiary"
              name={iconName}
              height="24px"
              width="24px"
            />
            <span className="flex-auto flex gap-8">{label}</span>
            {Boolean(notificationCount) && (
              <NotificationCount count={notificationCount} />
            )}
          </SmartLink>
        </FancyDropdownMenuItem>
      ))}
    </>
  );
}

UserHeaderLoggedInBuyerMenu.propTypes = {
  user: PropTypes.shape({
    entitlements: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  totalNotificationsCount: PropTypes.number.isRequired
};
